module.exports = __webpack_public_path__ + "static/17_Uber-1b41794afd4944974fb69a1be9b17c14.png";